import { FC } from 'react';
import { DagStatus } from '@agilelab/plugin-wb-builder-common';
import { customAlertApiRef } from '@agilelab/plugin-wb-platform';
import { configApiRef, useApi } from '@mainstage/core-plugin-api';
import useInterval from 'react-use/lib/useInterval';
import { panelCatalogApiRef } from '../../../api';
import { useEditorPageContext } from '../context/useEditorPageContext';
import { Test } from '../types';

interface Props {
  test: Test;
}

export const AsyncTestTableRow: FC<Props> = ({ test }) => {
  const panelCatalog = useApi(panelCatalogApiRef);
  const alertApi = useApi(customAlertApiRef);
  const configApi = useApi(configApiRef);
  const { fetchLastTest, fetchTests, setIsValidatingDescriptor } =
    useEditorPageContext();
  const pollingInterval =
    configApi.getOptionalNumber(
      'mesh.provisioner.validation.statusPolling.interval',
    ) ?? 3000;

  useInterval(async () => {
    panelCatalog
      .getValidateDescriptorStatus(test.id)
      .then(response => {
        if (response.status !== DagStatus.RUNNING) {
          fetchLastTest();
          fetchTests();
          setIsValidatingDescriptor(false);
        }
      })
      .catch(error => {
        alertApi.post({ error, severity: 'error' });
      });
  }, pollingInterval);

  return '';
};
